import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
const routes = [{
	path: "/",
	name: "login",
	component: () => import("@/views/login"),
}, {
	path: "/register",
	name: "register",
	component: () => import("@/views/register"),
}, {
	path: "/HomeView",
	name: "home",
	component: () => import("@/views/HomeView"),
}, {
	path: "/HomeList",
	name: "HomeList",
	meta: {
		index: '4'
	},
	component: () => import("@/views/HomeView"),
	children: [{
		path: '/HomeList/index',
		name: 'index',
		meta: {
			index: '4-1'
		},
		component: () => import( /* 房源列表 */ "@/views/HomeList/index"),
	}]
}, {
	path: "/userList",
	name: "userList",
	component: () => import("@/views/HomeView"),
	meta: {
		index: '1'
	},
	children: [{
		path: '/userList/user_manage',
		name: 'user_manage',
		meta: {
			index: '1-1'
		},
		component: () => import( /* 管理员管理 */ "@/views/userList/user_manage"),
	},{
		path: '/userList/user_managegroup',
		name: 'user_managegroup',
		meta: {
			index: '1-2'
		},
		component: () => import( /* 用户组管理 */ "@/views/userList/user_managegroup"),
	},{
		path: '/userList/account_manage',
		name: 'account_manage',
		meta: {
			index: '1-3'
		},
		component: () => import( /* 账户管理 */ "@/views/userList/account_manage"),
	},{
		path: '/userList/user_add',
		name: 'user_add',
		meta: {
			index: '1-2'
		},
		component: () => import( /* 管理员管理-新增 */ "@/views/userList/user_add"),
	}]
}, {
	path: "/base",
	name: "base",
	component: () => import("@/views/HomeView"),
	meta: {
		index: '4'
	},
	children: [{
		path: '/base/address',
		name: 'address',
		meta: {
			index: '4-1'
		},
		component: () => import( /* 地址管理 */ "@/views/base/address"),
	}]
}, {
	path: "/bookRoom",
	name: "bookRoom",
	component: () => import("@/views/HomeView"),
	meta: {
		index: '5'
	},
	children: [{
		path: '/bookRoom/index',
		name: 'address',
		meta: {
			index: '5-1'
		},
		component: () => import( /* 订单管理 */ "@/views/bookRoom/index"),
	}]
}, {
	path: "/policeList",
	name: "policeList",
	component: () => import("@/views/HomeView"),
	meta: {
		index: '3'
	},
	children: [{
		path: '/policeList/index',
		name: 'index',
		meta: {
			index: '3-1'
		},
		component: () => import( /* 民警账号管理 */ "@/views/policeList/index"),
	},{
		path: '/policeList/government',
		name: 'government',
		meta: {
			index: '3-2'
		},
		component: () => import( /* 管辖单位管理 */ "@/views/policeList/government"),
	}]
},{
	path: "/business",
	name: "business",
	component: () => import("@/views/HomeView"),
	meta: {
		index: '2'
	},
	children: [{
		path: '/business/index',
		name: 'index',
		meta: {
			index: '2-2'
		},
		component: () => import( /* 商户管理列表 */ "@/views/business/index"),
	},{
		path: '/business/audit',
		name: 'audit',
		meta: {
			index: '2-1'
		},
		component: () => import( /* 商户管理审核 */ "@/views/business/audit"),
	}]
},{
	path: "/systemsetup",
	name: "systemsetup",
	component: () => import("@/views/HomeView"),
	meta: {
		index: '6'
	},
	children: [{
		path: '/systemsetup/popularlist',
		name: 'popularlist',
		meta: {
			index: '6-1'
		},
		component: () => import( /* 系统设置-热门搜索 */ "@/views/systemsetup/popularlist"),
	},{
		path: '/systemsetup/metrolist',
		name: 'metrolist',
		meta: {
			index: '6-2'
		},
		component: () => import( /* 系统设置-地铁站 */ "@/views/systemsetup/metrolist"),
	},{
		path: '/systemsetup/attractionslist',
		name: 'attractionslist',
		meta: {
			index: '6-3'
		},
		component: () => import( /* 系统设置-景点 */ "@/views/systemsetup/attractionslist"),
	},{
		path: '/systemsetup/selectedlist',
		name: 'selectedlist',
		meta: {
			index: '6-4'
		},
		component: () => import( /* 系统设置-精选 */ "@/views/systemsetup/selectedlist"),
	},{
		path: '/systemsetup/servicelist',
		name: 'servicelist',
		meta: {
			index: '6-5'
		},
		component: () => import( /* 系统设置-客服 */ "@/views/systemsetup/servicelist"),
	},{
		path: '/systemsetup/recommendlist',
		name: 'recommendlist',
		meta: {
			index: '6-6'
		},
		component: () => import( /* 系统设置-商户推荐 */ "@/views/systemsetup/recommendlist"),
	}]
	
},{
	path: "/warning",
	name: "warning",
	component: () => import("@/views/HomeView"),
	meta: {
		index: '100'
	},
	children: [{
		path: '/warning/warninglist',
		name: 'warninglist',
		meta: {
			index: '100-1'
		},
		component: () => import( /* 系统设置-热门搜索 */ "@/views/warning/warninglist"),
	}]
}];
const router = new VueRouter({
	routes,
});
export default router;